import { ElementRef, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResizeObserverService {
  observeResize$(element: ElementRef): Observable<unknown> {
    return new Observable<unknown>((subscriber) => {
      const resizeObserver = new ResizeObserver((entries) => {
        subscriber.next(entries);
      });

      resizeObserver.observe(element.nativeElement);

      return {
        unsubscribe() {
          resizeObserver.unobserve(element.nativeElement);
        }
      };
    });
  }
}
